/** Маршруты MVP (MVP_PRD §5). Строки не дублируются по коду. */
export const ROUTES = {
  home: '/',
  // Публичная часть — главная и «О проекте». Каталог `/cars`, карточка
  // автомобиля `/cars/:slug` и страница цен `/preise` удалены по решению
  // заказчика 2026-08-27: витрины каталога в продукте нет, автомобили
  // пользователь видит только внутри своего заказа.
  about: '/ueber-uns',
  // Частые вопросы (тексты заказчика от 29.10.2026). Ссылка — в подвале.
  faq: '/faq',
  login: '/login',
  verify: '/verify',

  // Правовые страницы. Адреса немецкие: рынок DE, договорный язык немецкий, и
  // ссылка из письма или из решения суда должна открываться так же, как её
  // называет закон. Английские адреса `/privacy`, `/terms`, `/imprint`
  // остаются редиректами — они уже разосланы в письмах.
  imprint: '/impressum',
  privacy: '/datenschutz',
  terms: '/agb',
  withdrawal: '/widerruf',
  // Widerrufsfunktion по § 356a BGB (обязательна с 19.06.2026): доступна без
  // входа и в течение всего срока отзыва.
  withdrawalForm: '/widerruf/erklaerung',
  cookies: '/cookies',
  accessibility: '/barrierefreiheit',

  legacyPrivacy: '/privacy',
  legacyTerms: '/terms',
  legacyImprint: '/imprint',

  // `/app` — список запросов и стартовая страница авторизованного
  // пользователя (MVP_PRD §20). Запрос — первоклассная сущность с адресом,
  // поэтому диалог, результаты и карточка живут под его идентификатором:
  // ссылка на результаты одного запроса никогда не откроется в контексте
  // другого (AC-07).
  app: '/app',
  searchAssistant: (searchId = ':searchId') => `/app/searches/${searchId}/assistant`,
  // Шаг 2: прогон по каталогу — реальные этапы, реальные числа (FE-221).
  searchAnalysis: (searchId = ':searchId') => `/app/searches/${searchId}/analysis`,
  searchResults: (searchId = ':searchId') => `/app/searches/${searchId}/results`,
  // Шаг 4: четвёрка, сравнение и выбор автомобиля (FE-220, FE-222).
  searchTop4: (searchId = ':searchId') => `/app/searches/${searchId}/top4`,
  // Шаг 3 воронки: единственная точка, где требуется регистрация (MVP_PRD §41.2).
  searchPayment: (searchId = ':searchId') => `/app/searches/${searchId}/payment`,
  searchVehicle: (searchId = ':searchId', vehicleId = ':vehicleId') =>
    `/app/searches/${searchId}/cars/${vehicleId}`,
  // Старые адреса без идентификатора: остаются только ради редиректа на `/app`
  // (FE-151). Ссылки на них из кода больше не строятся.
  legacyAssistant: '/app/assistant',
  legacyResults: '/app/results',
  legacyAppVehicle: '/app/cars/:vehicleId',
  // Шаг 4: поручение на запрос сведений у четырёх автохаусов (FE-170).
  // Отдельный экран, а не окно: на нём список вопросов, режим автономности и
  // полный текст письма-образца — в модалку это не помещается (MVP_PRD §21.5).
  searchOutreach: (searchId = ':searchId') => `/app/searches/${searchId}/outreach`,
  // Шаг 4: запуск углублённой проверки по всем четырём (FE-400). Тоже экран:
  // на нём предупреждение о заморозке состава и списки вопросов по четырём
  // автомобилям — в окно это не помещается (MVP_PRD §34.4).
  // Шаг 6: заключение по сделке и финальная сверка (FE-250). Отдельный экран,
  // а не блок на карточке переписки: заключение собирается по заказу и может
  // охватывать несколько автомобилей, дошедших до финального предложения.
  searchConclusion: (searchId = ':searchId') => `/app/searches/${searchId}/conclusion`,
  // Шаг 7: сопровождение покупки (FE-260). Контакты автохауса, зафиксированные
  // условия, два чек-листа, памятки и отметка исхода. Экран, а не блок на
  // заключении: шаг 6 отвечает «что получилось по сделке», шаг 7 — «что делать
  // дальше», и это разные вопросы в разные моменты (MVP_PRD §39).
  searchHandover: (searchId = ':searchId') => `/app/searches/${searchId}/handover`,
  // Шаг 5: мандат на торг по выбранному автомобилю (FE-171). Тоже экран:
  // мобильный вариант проходится пошагово, и окно здесь не годится.
  searchMandate: (searchId = ':searchId', vehicleId = ':vehicleId') =>
    `/app/searches/${searchId}/mandate/${vehicleId}`,
  // Переговоры (FE-172, FE-173). Живут вне заказа: переписка переживает его
  // удаление — письма уже отправлены (MVP_TECH_RFC §23.10).
  negotiations: '/app/negotiations',
  negotiation: (negotiationId = ':negotiationId') => `/app/negotiations/${negotiationId}`,
  // Каналы уведомлений (FE-160, MVP_PRD §21.6). Экран вне воронки заказа:
  // канал принадлежит пользователю, а не запросу.
  negotiationChannels: '/app/negotiations/channels',
} as const;

/** Ключ sessionStorage для запроса, введённого на главной до авторизации. */
export const HERO_PROMPT_STORAGE_KEY = 'carviq.hero-prompt';
